import { Check } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../Accordion";
import type { AccordionEntry, FaqEntry } from "../../types/aquagym";
const contentEmojis: Record<string, string> = {
  "tomo-1": "🌊",
  "tomo-2": "🏊",
  "tomo-3": "💪",
  "tomo-4": "👵",
  "tomo-5": "🎵",
  "tomo-6": "📈",
  "tomo-7": "🏆",
  "bono-1": "📚",
  "bono-2": "📊",
  "bono-3": "🤰",
  "bono-4": "🏊",
  "bono-5": "🗓️"
};
interface ContentAccordionProps {
  entries: AccordionEntry[];
  kind: "volume" | "bonus";
  openItem: string;
  onOpenChange: (value: string) => void;
}
export function ContentAccordion({
  entries,
  kind,
  openItem,
  onOpenChange
}: ContentAccordionProps) {
  return <Accordion type="single" collapsible value={openItem} onValueChange={onOpenChange} className="space-y-3" data-id="element-5" data-mp="klbgb9g7ieuf">
      {entries.map(entry => {
      const referencePrice = entry.value?.match(/\$[\d.]+/)?.[0];
      return <AccordionItem key={entry.id} value={entry.id} className={`overflow-hidden rounded-2xl border bg-white px-4 shadow-[0_8px_30px_rgba(0,0,0,0.05)] transition-colors sm:px-6 ${kind === "bonus" ? "border-rose-200 data-[state=open]:border-rose-400" : "border-[#CBD5E1] data-[state=open]:border-[#22D3EE]"}`} data-id="element-6" data-mp="3o7s9dhhlhpkb">
          <AccordionTrigger className="gap-3 py-5 text-left hover:no-underline sm:py-6" data-id="element-7" data-mp="1jruqv07d35y2">
            <span className="flex min-w-0 items-start gap-3 sm:gap-4" data-id="element-8" data-mp="1eu1hxzeobxu3">
              <span className="flex size-9 shrink-0 items-center justify-center text-2xl leading-none sm:size-10 sm:text-3xl" role="img" aria-hidden="true" data-id="element-9" data-mp="1au0u5o5oqaad">
                {contentEmojis[entry.id]}
              </span>
              <span className="min-w-0 flex-1" data-id="element-10" data-mp="10vbmeo7i667u">
                <span className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2" data-id="element-11" data-mp="vvyo97b6lcpy">
                  <span className="min-w-0 whitespace-normal break-words text-[11px] font-black uppercase leading-snug tracking-[-0.01em] text-[#0C4A6E] sm:text-base" data-id="element-12" data-mp="2v8uf9kql90mt">
                    <span className="text-[#0284C7]" data-id="element-13" data-mp="2qaj5fa0amq4l">{entry.kicker}</span>
                    <span aria-hidden="true" data-id="element-14" data-mp="ojiynvshj8cx"> — </span>
                    {entry.title}
                  </span>
                  {kind === "bonus" && referencePrice ? <span className="inline-flex shrink-0 items-center rounded-lg border border-rose-200 bg-rose-50 px-2.5 py-1 text-[10px] font-black text-[#BE123C] sm:text-xs" data-id="element-15" data-mp="td3rl9f81c59">
                      <span className="mr-1 text-rose-400 line-through" data-id="element-16" data-mp="jlqzqhtfalz8">{referencePrice}</span>
                      <span aria-hidden="true" data-id="element-17" data-mp="17buyaarr7vjd">→</span>
                      <span className="ml-1" data-id="element-18" data-mp="1caenck1n9nfy">GRATIS</span>
                    </span> : null}
                </span>
                {entry.quote ? <span className="mt-1 block text-xs font-medium italic text-[#64748B] sm:text-sm" data-id="element-19" data-mp="y9lt80f98udd">“{entry.quote}”</span> : null}
              </span>
            </span>
          </AccordionTrigger>
          <AccordionContent className="pb-6 pl-0 text-[#475569] sm:pl-14" data-id="element-20" data-mp="3izt9dohh9kku">
            {entry.items.length > 0 ? <ul className="space-y-3" data-id="element-21" data-mp="3n2zbcjxk4pli">
                {entry.items.map(item => <li key={item} className="flex gap-3 text-sm leading-6 sm:text-base" data-id="element-22" data-mp="3fi5ibw49ysdd">
                    <Check className="mt-1 size-4 shrink-0 text-[#06B6D4]" aria-hidden="true" data-id="element-23" data-mp="3aju8hldzchv5" />
                    <span data-id="element-24" data-mp="3pgl038hewpa7">{item}</span>
                  </li>)}
              </ul> : null}
          </AccordionContent>
        </AccordionItem>;
    })}
    </Accordion>;
}
interface FaqAccordionProps {
  entries: FaqEntry[];
  openItem: string;
  onOpenChange: (value: string) => void;
}
export function FaqAccordion({
  entries,
  openItem,
  onOpenChange
}: FaqAccordionProps) {
  return <Accordion type="single" collapsible value={openItem} onValueChange={onOpenChange} className="space-y-3" data-id="element-25" data-mp="2rqzvuy3tx1u3">
      {entries.map(entry => <AccordionItem key={entry.id} value={entry.id} className="rounded-2xl border border-[#E2E8F0] bg-white px-5 shadow-sm sm:px-6" data-id="element-26" data-mp="31qqp6wgnlasl">
          <AccordionTrigger className="gap-4 py-5 text-left text-base font-bold text-[#0C4A6E] hover:no-underline sm:text-lg" data-id="element-27" data-mp="2e04rnz49z8wu">
            <span className="flex items-start gap-3" data-id="element-28" data-mp="290s6dit1y9wd">
              <div className="mt-0.5 size-5 shrink-0 text-[#0891B2]" aria-hidden="true" data-id="element-29" data-mp="1cc9690q2klnq" />
              {entry.question}
            </span>
          </AccordionTrigger>
          <AccordionContent className="pb-5 pl-8 text-sm leading-7 text-[#475569] sm:text-base" data-id="element-30" data-mp="1lc5zzgrbgapn">{entry.answer}</AccordionContent>
        </AccordionItem>)}
    </Accordion>;
}